@if (isInitialized) {
  <oe-flat-widget button style="cursor: pointer;" [modalComponent]="modalComponent"
    [icon]="{name: 'oe-evcs', color: 'normal'}" [title]="alias | translate">
    @if (isConnectionSuccessful) {
      <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.EVCS.AMOUNT_OF_CHARGING_STATIONS'| translate"
        [value]="evcssInCluster.length">
      </oe-flat-widget-line>
      @if (!isEvcsCluster) {
        <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.EVCS.TOTAL_CHARGING_POWER' | translate"
        [converter]="CONVERT_TO_WATT" [channelAddress]="component.id + '/ChargePower'"></oe-flat-widget-line>
      }
    } @else {
      <oe-flat-widget-line [name]="'EDGE.INDEX.WIDGETS.EVCS.CLUSTER_CONFIG_ERROR'| translate" leftColumnWidth="100">
      </oe-flat-widget-line>
    }
  </oe-flat-widget>
}
